<!-- <ion-header>
  <ion-toolbar color="white">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.contact' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" color="white">

  <div>
    <div class="ion-text-center">
      <ion-text class="font-20 font-med" color="dark">{{ 'CONTACT.msg.title' | translate }}</ion-text>
    </div>
    <div class="ion-margin">
      <div class="ion-text-center ion-margin">
        <ion-text class="font-14" color="dark">{{ 'CONTACT.msg.support' | translate }}</ion-text>
      </div>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-card class="ion-padding ion-no-margin ion-text-center" color="light" (click)="goSupportPage('enquiry')" button>
              <ion-icon class="center font-34" name="help-circle-outline"></ion-icon>
              <div>
                <ion-text class="font-12 font-semi" color="dark">{{ 'LIST.support_ticket.enquiry' | translate }}</ion-text>
              </div>
            </ion-card>
          </ion-col>
          <ion-col>
            <ion-card class="ion-padding ion-no-margin ion-text-center" color="light" (click)="goSupportPage('suggestion')" button>
              <ion-icon class="center font-34" name="chatbox-ellipses-outline"></ion-icon>
              <div>
                <ion-text class="font-12 font-semi" color="dark">{{ 'LIST.support_ticket.suggestion' | translate }}</ion-text>
              </div>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-padding ion-no-margin ion-text-center" color="light" (click)="goSupportPage('complaint')" button>
              <ion-icon class="center font-34" name="alert-circle-outline"></ion-icon>
              <div>
                <ion-text class="font-12 font-semi" color="dark">{{ 'LIST.support_ticket.complaint' | translate }}</ion-text>
              </div>
            </ion-card>
          </ion-col>
          <ion-col>
            <ion-card class="ion-padding ion-no-margin ion-text-center" color="light" (click)="goSupportPage('refund')" button>
              <ion-icon class="center font-34" name="arrow-back-circle-outline"></ion-icon>
              <div>
                <ion-text class="font-12 font-semi" color="dark">{{ 'LIST.support_ticket.refund' | translate }}</ion-text>
              </div>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    
  
    <div class="ion-margin ion-padding">
      <div class="ion-text-center">
        <ion-text class="font-14" color="dark">{{ 'CONTACT.msg.live' | translate }}</ion-text>
      </div>
      <ion-button expand="block" (click)="open('messenger')">
        {{ 'CONTACT.btn.chat' | translate }}
      </ion-button>
    </div>
    
  
    <div class="ion-margin-vertical ion-padding-vertical">
      <div class="ion-text-center">
        <ion-text class="font-14 font-med" color="dark">{{ 'CONTACT.msg.connect' | translate }}</ion-text>
      </div>
      
      <ion-grid class="full-width">
        <ion-row>
          <ion-col class="ion-align-self-center">
            <ion-icon class="center icon-large" name="logo-facebook" color="dark" (click)="open('facebook')"></ion-icon>
          </ion-col>
          <ion-col class="ion-align-self-center">
            <ion-icon class="center icon-large" name="logo-instagram" color="dark" (click)="open('instagram')"></ion-icon>
          </ion-col>
          <ion-col class="ion-align-self-center">
            <ion-icon class="center icon-large" name="logo-youtube" color="dark" (click)="open('youtube')"></ion-icon>
          </ion-col>
          <ion-col class="ion-align-self-center">
            <ion-icon class="center icon-large" name="mail-outline" color="dark" (click)="open('email')"></ion-icon>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  
</ion-content> -->

<app-ticket-detail [pageMode]="true" [backHelpPage]="backHelpPage" [backRatingPage]="backRatingPage" [ready]="ready"></app-ticket-detail>
